import {
	OnboardingQueryResponse,
	OnboardingData,
	OnboardingBeneficioItem,
	OnboardingTextAlert
} from '../types/onboarding.types'

/**
 * Transforma los datos raw de onboarding a un formato más usable
 * @param rawData - Datos raw de la query GraphQL
 * @returns Objeto con datos procesados o false si hay error
 */
export const transformOnboardingData = (
	rawData: OnboardingQueryResponse
): {
	onboardingData: OnboardingData | false
	textAlert: OnboardingTextAlert
	beneficioItems: OnboardingBeneficioItem[]
} => {
	try {
		if (!rawData?.homeCollection?.items?.[0]?.vistas?.onbording) {
			console.warn('No se encontraron datos de onboarding válidos')
			return {
				onboardingData: false,
				textAlert: {
					success: 'Se ha actualizado tus datos.',
					error: 'No se pudo guardar los cambios'
				},
				beneficioItems: []
			}
		}

		const onboardingData = rawData.homeCollection.items[0].vistas.onbording

		// Crear objeto de alertas de texto
		const textAlert: OnboardingTextAlert = {
			success: onboardingData.tituloGeneral || 'Se ha actualizado tus datos.',
			error: onboardingData.descripcionGeneral || 'No se pudo guardar los cambios'
		}

		// Obtener items de beneficios
		const beneficioItems = onboardingData.beneficioCollection?.items || []

		return {
			onboardingData,
			textAlert,
			beneficioItems
		}
	} catch (error) {
		console.error('Error al transformar datos de onboarding:', error)
		return {
			onboardingData: false,
			textAlert: {
				success: 'Se ha actualizado tus datos.',
				error: 'No se pudo guardar los cambios'
			},
			beneficioItems: []
		}
	}
}
